module.exports = __webpack_public_path__ + "a17d279f/img/document.e2130c6b.svg";